(function ($) {


  $(window).load(function () {
  });


  $(window).resize(function () {
  });


  $(window).load(function () {

    // Check that we are on the right page using .length before firing
    if ($('#masonry-grid').length) {
      masonryInit();
    }

  });


  $(document).ready(function () {

    // FAQs interaction
    if ($('.faqs-group').length) {
      $('.faqs-group .faq-row').each(function () {
        $(this).addClass('off');
      });
      $('.question').on('click', function () {
        $(this).parent().toggleClass('off');
      });
      $('#openfaqs').on('click', function () {
        $('.faqs-group .faq-row').each(function () {
          $(this).removeClass('off');
          $('#openfaqs').prop('disabled', true);
        });
      });
    }


    // Mobile navigation
    $('.menu-btn-toggle').click(function () {
      if ($('.nav-container').hasClass("nav-hide")) {
        $('.nav-container').removeClass("nav-hide");
        setTimeout(function () {
          $('.hideme').removeClass("nav-dis");
        }, 300);
        $('body').addClass('noscroll');
      } else {
        $('.hideme').addClass("nav-dis");
        setTimeout(function () {
          $('.nav-container').addClass("nav-hide");
        }, 500);
        $('body').removeClass('noscroll');
      }
    });

    // Sticky header init
    $(".sticky-header").stick_in_parent();


  });


  function masonryInit() {

    var $grid = jQuery('#masonry-grid');

    $grid.masonry({
      itemSelector: '.grid-item',
      gutter: 30,
      fitWidth: true
    });

    $grid.imagesLoaded().progress(function () {
      $grid.masonry('layout');
    });
  }

  equalheight = function (container) {

    var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;

    $(container).each(function () {

      $el = $(this);
      $($el).height('auto')
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }

    });

  }


})(jQuery); // Fully reference jQuery after this point.
